import React from "react";

const SessionHistoryTable = ({ loading, data }) => {
  return (
    <div className="mt-4 col-12 mx-auto shadow border rounded px-2 py-2">
      <div className="tab-content">
        <div className="table-responsive">
          {loading ? (
            <p>loading...</p>
          ) : (
            <table className="table mb-0">
              <thead className="thead-light">
                <tr>
                  <th
                    style={{
                      fontSize: "15px",
                      color: "#333333",
                      fontWeight: "500",
                    }}
                  >
                    Day date
                  </th>
                  <th
                    style={{
                      fontSize: "15px",
                      color: "#333333",
                      fontWeight: "500",
                    }}
                  >
                    Start time
                  </th>
                  <th
                    style={{
                      fontSize: "15px",
                      color: "#333333",
                      fontWeight: "500",
                    }}
                  >
                    End time
                  </th>
                  <th
                    style={{
                      minWidth: "140px",
                      fontSize: "15px",
                      color: "#333333",
                      fontWeight: "500",
                    }}
                  >
                    Student name
                  </th>
                  <th
                    style={{
                      fontSize: "15px",
                      color: "#333333",
                      fontWeight: "500",
                    }}
                  >
                    Subjects
                  </th>
                  <th
                    style={{
                      fontSize: "15px",
                      color: "#333333",
                      fontWeight: "500",
                    }}
                  >
                    Teacher name
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    {/* <td className="text-nowrap">{item?.id}</td> */}
                    <td className="text-nowrap">
                      {item?.day} {item?.date}
                    </td>
                    <td className="text-nowrap">{item?.startTime}</td>
                    <td className="text-nowrap">{item?.endTime}</td>
                    <td className="text-nowrap">{item?.student?.fullName}</td>
                    <td className="text-nowrap">
                      {item?.offer?.offerSubjects?.map((x, index) => (
                        <span
                          key={index}
                          className="badge bg-primary rounded-pill"
                        >
                          {x?.subjectName}
                        </span>
                      ))}
                    </td>
                    <td className="text-nowrap">
                      {item?.teacher?.fullName || "N/A"}
                    </td>
                    {/* <td className="text-nowrap">
                      <span
                        className={`badge rounded-pill ${
                          item?.offerSlot?.status === "completed"
                            ? "bg-success"
                            : "bg-danger"
                        }`}
                      >
                        {item?.offerSlot?.status}
                      </span>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionHistoryTable;
